// extracted by mini-css-extract-plugin
module.exports = {"primary":"#005eb6","secondary":"#393939","accent":"#ee8500","error":"#b80000","info":"#0b78d0","success":"#3a833c","warning":"#ba5b08"};